import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useRemoveProduct = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (id) => {
      console.log('Deleting product with ID:', id);
      const res = await api.delete(`/product/${id}`);
      return res.data;
    },
    onSuccess: () => {
      queryClient.invalidateQueries(['viewProduct']);
      queryClient.invalidateQueries({ queryKey: ['viewSubscription'] });
    },
  });
};